module.exports = __webpack_public_path__ + "static/media/GESSTwoMedium-Medium.4728272d.woff";